export default __webpack_public_path__ + "static/media/img2.5f8fe915.jpg";